import HTTP from '.';
import ExpenseServiceMock from './mocks/ExpenseService.mock';
import config from '@/config';

export default class ExpenseService {
  static getExpenseTypes() {
    if (config.ENV.MOCK === true) {
      return ExpenseServiceMock.getExpenseTypes();
    }

    return HTTP.get('/api/expensetypes');
  }

  static getExpenseByTimeEntryIdAndExpenseId(timeEntryId, expenseId) {
    if (config.ENV.MOCK === true) {
      return ExpenseServiceMock.getExpenseByTimeEntryIdAndExpenseId();
    }

    return HTTP.get(
      `/api/currentmember/timeentries/${timeEntryId}/expenses/${expenseId}`,
    );
  }

  static addExpense(timeEntryId, data) {
    if (config.ENV.MOCK === true) {
      return ExpenseServiceMock.addExpense();
    }

    return HTTP.post(
      `/api/currentmember/timeentries/${timeEntryId}/expenses/`,
      data,
    );
  }

  static deleteExpense(timeEntryId, expenseId) {
    if (config.ENV.MOCK === true) {
      return ExpenseServiceMock.deleteExpense();
    }

    return HTTP.delete(
      `/api/currentmember/timeentries/${timeEntryId}/expenses/${expenseId}`,
    );
  }

  static saveExpense(timeEntryId, expense) {
    if (config.ENV.MOCK === true) {
      return ExpenseServiceMock.saveExpense();
    }

    return HTTP.put(
      `/api/currentmember/timeentries/${
        timeEntryId
      }/expenses/${
        expense.id}`,
      expense,
    );
  }
}
